"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
var theme_ui_1 = require("theme-ui");
var BGImageBox_1 = require("../../atoms/BGImageBox/BGImageBox");
var Card = function (_a) {
    var bgImage = _a.bgImage, gradient = _a.gradient, children = _a.children, _b = _a.csx, csx = _b === void 0 ? {} : _b;
    return (theme_ui_1.jsx(BGImageBox_1.BGImageBox, { img: bgImage, gradient: gradient, csx: __assign({ display: "flex", justifyContent: "flex-end", alignItems: "flex-start", flexDirection: "column", backgroundSize: "cover", backgroundRepeat: "no-repeat", minWidth: "300px", height: "325px", pl: ["10px", "45px"], pb: ["22px", "45px"] }, csx) }, children));
};
exports.Card = Card;
